var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowhead(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.9998C11.7664 16.0002 11.5399 15.9189 11.36 15.7698L5.36003 10.7698C5.15581 10.6 5.02739 10.3561 5.00301 10.0917C4.97863 9.82728 5.06029 9.564 5.23003 9.35979C5.39977 9.15557 5.64368 9.02715 5.90811 9.00277C6.17253 8.97839 6.43581 9.06005 6.64003 9.22979L12 13.7098L17.36 9.38979C17.4623 9.30672 17.58 9.24469 17.7064 9.20726C17.8327 9.16983 17.9652 9.15773 18.0962 9.17167C18.2272 9.18561 18.3542 9.22531 18.4699 9.28848C18.5855 9.35166 18.6875 9.43706 18.77 9.53979C18.8616 9.64261 18.931 9.76324 18.9738 9.89411C19.0166 10.025 19.0319 10.1633 19.0187 10.3003C19.0056 10.4374 18.9643 10.5703 18.8974 10.6906C18.8305 10.811 18.7395 10.9162 18.63 10.9998L12.63 15.8298C12.4449 15.9553 12.2231 16.0152 12 15.9998Z",
    fill: "#595959"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowhead);
export default __webpack_public_path__ + "static/media/arrowhead.10f413cd1442858db5540f06ca6cb7e0.svg";
export { ForwardRef as ReactComponent };